import styled from "styled-components";

const Color = styled.div`
  width: 54px;
  height: 138px;
  border-radius: 5px;
  background-color: ${(props) => props.bcolor};
`;

const ParentContainer = styled.div`
  position: relative;
  z-index: 10;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: "";
    position: absolute;
    height: 105%;
    width: 107%;
    background-color: ${(props) =>
      props.selected ? "#fe6030" : "transparent"};
    transform: rotate(-3deg);
    border-radius: 5px;
    z-index: -1;
  }
`;

export const ColorItem = ({ bcolor, onClick, selected }) => {
  return (
    <ParentContainer selected={selected}>
      <Color bcolor={bcolor} onClick={onClick} />
    </ParentContainer>
  );
};
